import React, { useState } from 'react';
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
import { EventsSegment } from '../../../helpers/EventsSegmentsCalculators';
import * as S from './styles';
import { useSelectedPlan } from '../useSelectedPlan';
import { mapOfferToSubscriptionPlan } from '../../../hooks/useSubscriptionPlans/mapOfferToSubscriptionPlan';
import { usePlansCatalog } from '../../../hooks/useSubscriptionPlans/usePlansCatalog';
import { useCatalogUnresolvableRedirect } from '../../../hooks/useSubscriptionPlans/useCatalogUnresolvableRedirect';
import { NEW_TIER_BENEFITS_BY_KEY } from '../../../hooks/useSubscriptionPlans/newTierBenefits';
import { getUpgradeOptions } from '../../../hooks/useSubscriptionPlans/getUpgradeOptions';
import { toast } from 'react-toastify';
import { isNil } from 'lodash';

export default function ChoosePlan(props) {
  const { LimitReachModal } = EventsSegment();
  const isOffer = props?.isOffer;
  const {
    currentTier = 'grandfathered',
    isReactivationFlow = false,
    isOpen = false,
    onClose = () => {},
  } = props;
  const {
    plans: catalogPlans,
    isLoading: isCatalogLoading,
    error: catalogError,
    refetch: refetchCatalog,
  } = usePlansCatalog();
  // Sem isso, o cliente com status irresolvível via o card vazio pra sempre
  // (sem redirect pro subsistema de regularização já existente).
  useCatalogUnresolvableRedirect({ error: catalogError, isOpen, onClose });
  const newTierPlans = catalogPlans.filter((plan) =>
    getUpgradeOptions(currentTier, {
      forReactivation: isReactivationFlow,
    }).includes(plan.key),
  );

  const { selectedChoosePlan } = useSelectedPlan();

  const [toggledBenefits, toggleBenefits] = useState(false);
  const [showBenefits, setShowBenefits] = useState(false);

  if (catalogError === 'SUBSCRIPTION_STATUS_UNRESOLVABLE') {
    return null;
  }

  const toggleBenefit = (e) => {
    e.stopPropagation();
    const isHide = !toggledBenefits === false;
    toggleBenefits(!toggledBenefits);
    if (isHide) {
      setTimeout(() => {
        setShowBenefits(false);
      }, [1000]);
    } else {
      setShowBenefits(true);
    }
  };
  const filteredPlans = newTierPlans.map((plan) => ({
    key: plan.key,
    benefits: NEW_TIER_BENEFITS_BY_KEY[plan.key],
  }));
  const effectivePlanPrices = newTierPlans.reduce((acc, plan) => {
    acc[plan.key] = { title: plan.title, price: plan.price, total: '' };
    return acc;
  }, {});
  const renderBenefits = (benefits) => {
    return isOffer ? (
      <S.ContainerBenefits toggled={toggledBenefits}>
        <S.ToggleBenefits onClick={toggleBenefit}>
          {toggledBenefits ? 'Esconder benefícios' : 'Ver benefícios'}
        </S.ToggleBenefits>
        <ul className="list-benefit-slider">
          {showBenefits &&
            benefits.map((benefit, index) => (
              <li key={index}>
                <i
                  className={
                    benefit.enabled
                      ? 'icon-lg fas fa-check'
                      : 'icon-lg fas fa-times disabled'
                  }
                ></i>{' '}
                <span>{benefit.description}</span>
              </li>
            ))}
        </ul>
      </S.ContainerBenefits>
    ) : (
      <ul>
        {benefits.map((benefit, index) => (
          <li key={index}>
            <i
              className={
                benefit.enabled
                  ? 'icon-lg fas fa-check'
                  : 'icon-lg fas fa-times disabled'
              }
            ></i>{' '}
            <span>{benefit.description}</span>
          </li>
        ))}
      </ul>
    );
  };

  const chooseProduct = (plan) => {
    LimitReachModal('Limit Reach Upgrade Button Clicked', {
      context: props.url,
    });

    const offer = catalogPlans.find((catalogPlan) => catalogPlan.key === plan);
    const subscriptionPlan = offer && mapOfferToSubscriptionPlan(offer, plan);

    const subscriptionPlanNotFound = !subscriptionPlan;
    const invalidIdentifiers =
      subscriptionPlan &&
      (isNil(subscriptionPlan.id) || isNil(subscriptionPlan.gateway_id));
    const hasNonNumericId =
      subscriptionPlan && typeof subscriptionPlan.id !== 'number';
    const hasErrors =
      subscriptionPlanNotFound || invalidIdentifiers || hasNonNumericId;

    if (hasErrors) {
      toast.error(
        'Plano não encontrado. Por favor, tente novamente ou contate o suporte.',
      );
      props.formik.setFieldValue('product_selected', null);
      return;
    }

    const productSelected = {
      id: subscriptionPlan.id,
      name: subscriptionPlan.name,
      description: subscriptionPlan.description,
      periodicity: subscriptionPlan.billingCycle,
      price: subscriptionPlan.amount,
      gateway_id:
        subscriptionPlan.gateway_id != null
          ? String(subscriptionPlan.gateway_id)
          : null,
    };

    props.formik.setFieldValue('product_selected', productSelected);
  };

  return (
    <S.Content>
      <h3>{props.title}</h3>
      <p>{props.subtitle}</p>

      <div className="row">
        {isCatalogLoading && <p role="status">Carregando planos...</p>}
        {!isCatalogLoading && catalogError === 'PRICING_CATALOG_INCOMPLETE' && (
          <p role="alert">
            Não foi possível carregar os planos. Tente novamente em instantes ou entre em contato
            com o suporte.
            <br />
            <button type="button" onClick={refetchCatalog}>
              Tentar novamente
            </button>
          </p>
        )}
        {!isCatalogLoading && !catalogError && filteredPlans.length === 0 && (
          <p>
            Não encontramos planos disponíveis no momento. Tente novamente mais tarde ou entre em
            contato com o suporte.
          </p>
        )}
        {!isCatalogLoading && !catalogError && filteredPlans.map((plan) => (
          <S.PlanContainer
            key={plan.key}
            className={filteredPlans.length > 1 ? 'col-lg-4' : 'col-12'}
          >
            <S.Produto onClick={() => chooseProduct(plan.key)}>
              <S.PlanTitleContainer>
                <span>{effectivePlanPrices?.[plan.key]?.title}</span>
                {isOffer && effectivePlanPrices?.[plan.key]?.former_price ? (
                  <S.OfferIcon
                    src={toAbsoluteUrl('/media/svg/tag-discount-50.svg')}
                  />
                ) : null}
              </S.PlanTitleContainer>
              <p className="preco">
                {isOffer && effectivePlanPrices?.[plan.key]?.former_price ? (
                  <>
                    de{' '}
                    <S.FormerPrice>
                      {effectivePlanPrices?.[plan.key]?.former_price}
                    </S.FormerPrice>{' '}
                    {effectivePlanPrices?.[plan.key]?.price}
                  </>
                ) : (
                  <>
                    {effectivePlanPrices?.[plan.key]?.price}{' '}
                    <span style={{ fontWeight: 500 }}>
                      {effectivePlanPrices?.[plan.key]?.total}
                    </span>
                  </>
                )}
              </p>
              {renderBenefits(plan.benefits)}

              <S.SignButton className="btn btn-primary ">
                <span>Assinar agora</span>
                <img
                  src={toAbsoluteUrl('/media/arrow-white.svg')}
                  className="arrow-icon"
                />
              </S.SignButton>
            </S.Produto>
          </S.PlanContainer>
        ))}
      </div>
    </S.Content>
  );
}
